export default __webpack_public_path__ + "static/taskdefinition7-344f34436452c3e5a0816154876f81a7.png";